import { propStyles } from 'src/utils/propStyles';
import { styled } from 'src/utils/styled';

const FilterDropdownHeader = styled<any, any>(
    'div',
    'filterDropdownHeader',
    'filterItemDropdown'
)`
    ${propStyles};
`;

FilterDropdownHeader.defaultProps = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: 'sm',
    fontFamily: 'heading',
    fontWeight: 'medium',
    color: 'body',
    margin: '0 0 0.5em 0',
};

export default FilterDropdownHeader;



// WEBPACK FOOTER //
// ./src/Components/Filters/Components/StyledComponents/FilterDropdownHeader.tsx